<template>
    <div class="support-actions">
        <div @click="click(service)" v-bind:key="service.name" v-for="service in services" class="support-action">
            <h4>{{ service.name }}</h4>
            <i :class="getClassObject(service)"></i>
        </div>

        
        <!-- <div :class="{ 'support-action': true, 'shifted': movedRight }">
            <h4>Get Support</h4>
            <i class="fas fa-life-ring"></i>
        </div> 

        <div class="toggles">
            <button :disabled="!movedRight" @click="scrollLeft()" type="button" class="support-action-toggle"><i class="fas fa-angle-left"></i>
            </button>
            <button :disabled="movedRight" @click="scrollRight()" type="button" class="support-action-toggle"><i
                    class="fas fa-angle-right"></i></button> -->
        </div>
    </div>
</template>

<script>
import Config from '../../config';
export default {
  name: "SupportItemsComponent",
  methods: {
    getClassObject(service) {
      let baseClasses = {
        fas: true,
      };

      if (!service.icon) return;

      baseClasses["fa-".concat(service.icon.toLowerCase())] = true;

      return baseClasses;
    },
    click(service) {
      if(service.route) {
        this.$router.push({name: service.route});
      } else if(service.url) {
          window.location.href = service.url;
      }
    },
  },
  data: function () {
    return {
      services: [
        {
          name: "Order Web Hosting",
          icon: "hdd",
          route: 'hosting.shared'
        },
        {
          name: "Order A VPS",
          icon: "server",
          route: "hosting.vps",
        },
        {
          name: "Get Support",
          icon: "globe",
          url: Config.urls.support,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
support-action.shifted {
  transform: translateX(-180px);
}

.support-actions {
  .support-action {
    cursor: pointer;
    position: relative;
    display: inline-block;
    padding: 12px;
    margin-right: 10px;
    box-shadow: 3px 3px 2px 0px rgba(183, 183, 183, 0.24);
    background: #fff;
    border-radius: 15px;
    width: 178px;
    height: 100px;
    overflow: hidden;
    transition: transform 1s ease;
    &:before {
      position: absolute;
      display: block;
      content: "";
      height: 120px;
      width: 120px;
      background: #f4f6f8;
      top: -5px;
      border-radius: 50%;
      right: -30px;
      z-index: 1;
    }
    h4 {
      font-size: 18px;
      z-index: 10;
      position: relative;
    }
    i {
      font-size: 38px;
      margin-top: 10px;
    }
  }
  margin-top: 40px;
  width: 570px;
  height: 140px;
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
}

.support-action {
  &:nth-child(1) i {
    color: #6fbc9a;
  }
  &:nth-child(2) i {
    color: #098ce0;
  }
  &:nth-child(3) i {
    color: #ffcd0d;
  }
  &:nth-child(4) i {
    color: #ff5722;
  }
}

@media (max-width: 768px) {
  .support-actions {
    display: block;
    height: auto;
    white-space: initial;
    overflow: hidden;
    width: 100%;

    .support-action {
      width: 100%;
    }
  }
}

.toggles {
  position: absolute;
  right: 5px;
  button {
    border: 0;
    border-radius: 10px;
    background: #f8fafc;
    color: #0e324d;
    font-size: 17px;
    box-shadow: 0px 0px 3px #b7b7b7;
  }
}

.support-action-toggle:disabled {
  cursor: not-allowed;
  background: #ccc;
  color: #0c202f;
}

.toggles button:focus {
  outline: 0;
}
</style>